<template>
  <v-text-field
    variant="outlined"
    color="secondary"
    :label="required ? '*' + label : label"
    :placeholder="placeholder"
    :prepend-inner-icon="icon"
    :name="fieldKey"
    :type="type"
    :mask="mask"
    :hint="hint"
    :error-messages="errorMessages"
    :model-value="modelValue"
    :disabled="disabled"
    :autocomplete="autocomplete"

    :class="{'ime-off': imeOff}"
    @keyup.enter="$emit('keyup-enter')"

    @change="$emit('change')"

    @update:model-value="$emit('update:model-value', $event)"
  />
</template>

<script>
  import InputMixin from './InputMixin'

  export default {
    mixins: [InputMixin],
    props: {
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      },
      mask: {
        type: String,
        default: ''
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      imeOff: Boolean,
      modelValue: {
        type: String,
        default: ''
      }
    },
    emits: [
      'keyup-enter',
      'change',
      'update:model-value'
    ]
  }
</script>

<style>
</style>
